module.exports = __webpack_public_path__ + "img/fig29.ecdae38d.jpg";